import React from "react";
import { Link } from "react-router-dom";

export default function RequestQuateSection() {
  return (
    <>
      <section
        className="fun-fact start-count counterSection section-padding RequestQuateSection"
        style={{
          backgroundImage: "url('../images/img-1.jpg')",
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="container">
          <div className="row content">
            <div className="col-lg-12 col-sm-12 col-xs-12">
              <div className="box">
                <h3 className="headingRequestQuateSection">
                  {/* Are you ready to start your business? */}
                  Need help? Let's talk.
                  <br />
                  <small>Schedule a meeting for discussion</small>
                </h3>

                {/* Need a help? Let's talk. Schedule a meeting for discussion */}
                <Link to="/contact" className="btn-default">
                  <span>Request Quote</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
